import { get, post, postImg } from "@/util/http"
import ApiContainer from "../url"
const cultureApi = {
  cultureList: params => get(ApiContainer.cultureList, params),  //获取文化列表
  getCultureInfoById: params => get(ApiContainer.getCultureInfoById, params),//通过ID查询数据
  getEnforcementList: params => get(ApiContainer.getEnforcementList, params),//查询文化类别列表数据
  updateActivity:params=>post(ApiContainer.updateActivity,params),//更新文化站数据
  heritageList:params=>get(ApiContainer.heritageList,params),//获取非遗列表
}
export default cultureApi